<template>
  <div>
    <br />
    <input v-model="okCorreoVerde" type="checkbox" class="aceptacion" /> Aplicar
    este e-mail a todas mis pólizas.
  </div>
</template>

<script>
export default {
  data() {
    return {
      okCorreoVerde: true
    };
  }
};
</script>

<style lang="scss" scoped>
.aceptacion {
  font-size: 0.85rem;
}
</style>
